"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Button_1 = require("./Button");
exports.default = Button_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/button/lib/index.js
// module id = ./node_modules/@react-mdc/button/lib/index.js
// module chunks = 1